import React from "react"
import Particles from "react-tsparticles"

interface ParticleProps {
  lightMode: boolean
}

interface ParticleConfig {
  particles: {
    number: {
      value: number
      density: {
        enable: boolean
      }
    }
    color: {
      value: string
    }
    opacity: {
      value: number
    }
    size: {
      value: number
      random: boolean
      anim: {
        speed: number
        size_min: number
      }
    }
    line_linked: {
      enable: boolean
    }
    move: {
      enable: boolean
      random: boolean
      speed: number
      direction: 'top'
      out_mode: 'out'
    }
  }
}

const Particle: React.FC<ParticleProps> = ({ lightMode }) => {
  const paramConfig = {
    particles: {
      number: {
        value: 160,
        density: {
          enable: false
        }
      },
      color: {
        value: "#ffffff"
      },
      opacity: {
        value: 0.1
      },
      size: {
        value: 5,
        random: true,
        anim: {
          speed: 4,
          size_min: 0.3
        }
      },
      line_linked: {
        enable: false
      },
      move: {
        enable: true,
        random: true,
        speed: 1,
        direction: 'top',
        out_mode: 'out'
      }
    }
  }

  const paramConfigLight = {
    particles: {
      number: {
        value: 160,
        density: {
          enable: false
        }
      },
      color: {
        value: "#000000"
      },
      opacity: {
        value: 0.1
      },
      size: {
        value: 5,
        random: true,
        anim: {
          speed: 4,
          size_min: 0.3
        }
      },
      line_linked: {
        enable: false
      },
      move: {
        enable: true,
        random: true,
        speed: 1,
        direction: 'top',
        out_mode: 'out'
      }
    }
  }

  return (
    <Particles
      className="mi-home-particle"
      options={lightMode ? (paramConfigLight as any) : (paramConfig as any)}
    />
  )
}

export default Particle
